"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MakePrimaryPhone = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var constants_1 = require("../../../constants");
var phones_1 = require("../../../actions/phones");
var commonweb_utils_1 = require("commonweb-utils");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var icons_component_1 = require("../../../components/icons.component");
var interpolate_component_1 = require("../../../components/interpolate-component");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var ErrorContentMapper_1 = require("../../../utils/errorcodes/ErrorContentMapper");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var utils_1 = require("../../../common/utils/phones/utils");
var phone_1 = require("../../../utils/container/phone");
var page = require("page");
var MakePrimaryPhone = /** @class */ (function (_super) {
    tslib_1.__extends(MakePrimaryPhone, _super);
    function MakePrimaryPhone(props) {
        var _this = _super.call(this, props) || this;
        _this.submitHandler = function (event) {
            event.preventDefault();
            _this.setState({
                showSpinner: true,
                errorMessage: "",
            });
            var formData = {};
            formData["id"] = _this.state.id;
            formData["callPref"] = _this.state.callPref;
            formData["textPref"] = _this.state.textPref;
            formData["isTcpaEnabled"] = _this.state.enableTcpa;
            formData["isSCAEnabled"] = utils_1.isSCAEnabled(_this.props.features);
            ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + constants_1.default.ROUTES.API.PHONES.MAKE_PRIMARY, formData, { component: { name: constants_1.default.VIEWS.PHONES.MAKE_PRIMARY } })
                .then(function (phoneInfo) {
                if (phoneInfo && phoneInfo.phones) {
                    phoneInfo.phones = commonUtils_1.modifyObjectWithFactorById(phoneInfo.phones, _this.state.id, constants_1.default.VIEWS.PHONES.TOAST_INTENTS.SET_PRIMARY, true);
                    _this.props.dispatchPhonePrimary(phoneInfo);
                }
                _this.props.performedAction(constants_1.default.VIEWS.PHONES.TOAST_INTENTS.SET_PRIMARY);
                _this.setState({ showSpinner: false });
                page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.MANAGE);
            })
                .catch(function (error) {
                var errorMessage = ErrorContentMapper_1.getPhoneErrorContent(error, _this.props.content);
                _this.setState({
                    showSpinner: false,
                    errorMessage: errorMessage,
                });
                triggerOperationResult_1.triggerOperationResult(_this.props.phoneFpti.makePrimary, constants_1.default.FPTI.FAILURE, errorMessage);
                return;
            });
        };
        var inputParams = _this.props.route.enter.params.id.split("-"), setPrimaryPhoneId = inputParams[0], changePrimaryCallPref = inputParams[1], changePrimaryTextPref = inputParams[2], phonesList = _this.props.phones, setPrimaryPhoneNumber = "", currentCallPref = true, currentTextPref = true, phoneToBePrimary = commonUtils_1.findObjectInListById(phonesList, setPrimaryPhoneId), enableTcpa = true;
        if (phoneToBePrimary) {
            setPrimaryPhoneNumber = phoneToBePrimary.maskedSubscriberNumber;
            currentCallPref = phoneToBePrimary.callPref;
            currentTextPref = phoneToBePrimary.textPref;
            enableTcpa = phone_1.isTcpaEnabled(phoneToBePrimary, _this.props);
        }
        _this.state = {
            id: setPrimaryPhoneId,
            setPrimaryPhoneNumber: setPrimaryPhoneNumber,
            errorMessage: "",
            showSpinner: false,
            enableTcpa: enableTcpa,
            callPref: changePrimaryCallPref
                ? changePrimaryCallPref === "T"
                : currentCallPref,
            textPref: changePrimaryTextPref
                ? changePrimaryTextPref === "T"
                : currentTextPref,
        };
        return _this;
    }
    MakePrimaryPhone.prototype.render = function () {
        var phoneContent = this.props.content.phones;
        var commonContent = this.props.content.common;
        var phoneNumber = this.state.setPrimaryPhoneNumber;
        var setPrimaryConfirmationMessage = interpolate_component_1.InterpolateLinksWithComponent(phoneContent.changeprimary.confirmation.message, [phoneNumber]);
        return (React.createElement("div", { className: "generic-container" },
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "alignLeft nameAlert" }, this.state.errorMessage)) : null,
            React.createElement(icons_component_1.IllustrationComponent, { modifierClass: "successImg", image: "Info" }),
            React.createElement(pp_react_1.Text, { size: "xl3", className: "name-header" }, phoneContent.changeprimary.confirmation.title),
            React.createElement(pp_react_1.Text, { size: "md", className: "infoPages-description" }, setPrimaryConfirmationMessage),
            React.createElement(pp_react_1.Button, { className: "infoPages-btn", disabled: this.state.showSpinner, onClick: this.submitHandler, id: "test_makePrimaryButton", "data-name": this.props.phoneFpti.makePrimarySubmit }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: "loading", inverse: true })) : (React.createElement(pp_react_1.Text, { size: "md", className: "ok-button" }, commonContent.confirm)))));
    };
    return MakePrimaryPhone;
}(React.Component));
exports.MakePrimaryPhone = MakePrimaryPhone;
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, features = _a.features, account = _a.account, fpti = _a.fpti;
    var phones = commonweb_utils_1.objectUtils.safeGet(account, "phones.phones") || {}, phoneFpti = fpti.phones;
    phones = utils_1.changeNumberFormatForNonSCARegions(phones, utils_1.isSCAEnabled(features));
    return {
        _csrf: _csrf,
        ui: ui,
        content: content,
        route: route,
        phones: phones,
        phoneFpti: phoneFpti,
        features: features,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchPhonePrimary: function (phones) { return dispatch(phones_1.changePhone(phones)); },
        performedAction: function (typeOfAction) {
            return dispatch(phones_1.actionClicked(typeOfAction));
        },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(MakePrimaryPhone);
